module.exports = __webpack_public_path__ + "static/media/dna_step0.c5c7ecb2.svg";